import { type AppEnv, EnvName } from '@/types';

export const AppEnvironment: AppEnv = {
	appEnv: EnvName.Staging,
	patchVersion: 1,
	versionName: '0.0.1',
};
